import { Atom } from "AppReact";
import styled from "styled-components";

const template = styled.div`
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  max-height: 100%;
  max-width: 100%;
  transform: translate(-50%, -50%);
`;

export default Atom({ type: 'label', dataType: 'object', template });
